import { StringParam, useQueryParam, withDefault } from 'use-query-params';

export const useImpersonate = () => {
    const [impersonateToken] = useQueryParam('impersonateToken', withDefault(StringParam, localStorage.getItem('impersonateToken')));
  
  return {
    impersonateToken,
  }
}